import * as React from "react"
import { createFormHookContexts } from "@tanstack/react-form"
import { Store, useStore } from "@tanstack/react-store"
import FormItemContext from "./FormItemContext"

const { fieldContext, formContext, useFormContext } = createFormHookContexts()

const fallbackFieldStore = new Store({
  meta: {
    errors: [],
  },
})

const useFieldContext = () => {
  const { id } = React.useContext(FormItemContext)
  const field = React.useContext(fieldContext)

  const errors = useStore(
    field?.store ?? fallbackFieldStore,
    (state) => state.meta.errors,
  )

  if (!field) {
    throw new Error("useFieldContext should be used within <FormItem>")
  }

  const { name, store, state, ...restFieldContext } = field

  return {
    id,
    name,
    formItemId: `${id}-form-item`,
    formDescriptionId: `${id}-form-item-description`,
    formMessageId: `${id}-form-item-message`,
    errors,
    store,
    state,
    ...restFieldContext,
  }
}

export { fieldContext, formContext, useFieldContext, useFormContext }
